module.exports = __webpack_public_path__ + "static/media/miljo.8bd9f5b8.mp3";